var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0003 0.166687C11.7403 0.166687 0.166992 11.74 0.166992 26C0.166992 40.26 11.7403 51.8334 26.0003 51.8334C40.2603 51.8334 51.8337 40.26 51.8337 26C51.8337 11.74 40.2603 0.166687 26.0003 0.166687ZM26.0003 7.91669C30.2887 7.91669 33.7503 11.3784 33.7503 15.6667C33.7503 19.955 30.2887 23.4167 26.0003 23.4167C21.712 23.4167 18.2503 19.955 18.2503 15.6667C18.2503 11.3784 21.712 7.91669 26.0003 7.91669ZM26.0003 44.6C19.542 44.6 13.8328 41.2934 10.5003 36.2817C10.5778 31.1409 20.8337 28.325 26.0003 28.325C31.1412 28.325 41.4228 31.1409 41.5003 36.2817C38.1678 41.2934 32.4587 44.6 26.0003 44.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.d8298d08a3a12e85a16ce9e651a770f7.svg";
export { ForwardRef as ReactComponent };